<popper ref="popper" class="multiselect" :class="popperContentClass">

    <!-- Search box for multiselect -->
    <div slot="anchor" @click="onAnchorClick" class="multiselect__anchor">

        <simple-chip v-for="v in value" :text='toText(v)' :removable='!disabled' class="multiselect__chip"
            @dismiss="onChipRemove(v)">
        </simple-chip>

        <input :disabled="disabled" v-model="textInput" ref="input" :placeholder="placeholder" class="multiselect__input" type="text"
            @focus="onInputFocus" @blur="onBlur" @keydown.tab="onKeyTab"
            @input="onInput" @keydown.delete="onKeyDelete" @keydown.down="onKeyDown" @keydown="showPopper"/>

        <spinner v-if="loading" class="multiselect__loading"></spinner>
        <mom-icon class="multiselect__drop-down" svgIcon="drop-down"></mom-icon>
    </div>

    <!-- Dropdown options -->
    <div v-if="!disabled" @click="onOptionSelect(option)" class="multiselect__option" v-for="(option, index) in options"
        :ref="'optionLabel'" @keydown="onOptionsKeyDown($event, option)" :tabindex="index">
        <slot :option="option">
            {{ toText(option) }}
        </slot>
    </div>

    <!-- Message when empty list found -->
    <slot name="empty" v-if="optionsEmpty">
        <div class="multiselect__no-records">No matching record found</div>
    </slot>

</popper>
